import React, { useMemo } from 'react';

import { Link } from 'gatsby';

import {
  ASPECT_RATIO_LANDSCAPE,
  OverviewSlider,
  useSliderViewport,
} from '@mewa/ui';

import Image from '../../components/image';
import { PageFindResultData } from '../../components/search/types';

const imageWidth = 552;
const imageHeight = 414;

const fourByThreeCardImages = (src: string) => [
  {
    src,
    media: '',
    width: imageWidth,
    height: imageHeight,
  },
];

export const SearchResultBrandTopics = React.memo(
  ({ results }: { results: PageFindResultData[] }) => {
    const sliderViewport = useSliderViewport();

    const slides = useMemo(
      () =>
        results.map((result) => {
          return {
            image: (
              <Image
                images={fourByThreeCardImages(result.meta.image ?? '')}
                alt=""
              />
            ),
            wrapperLink: <Link to={result.url}>{result.meta.title}</Link>,
          };
        }),
      [results],
    );

    return (
      <OverviewSlider
        viewport={sliderViewport}
        aspectRatio={ASPECT_RATIO_LANDSCAPE}
        slides={slides}
      ></OverviewSlider>
    );
  },
);
